import dbStorageService from '../dbStorageService';
// ASG services removed - medication and health check notifications disabled
// import medicationService from '../../_archive/asg/services/medicationService';
// import healthCheckService from '../../_archive/asg/services/healthCheckService';
import { createNotification } from './notificationCreator';
import { NOTIFICATION_TYPES } from './constants';

/**
 * Clean up duplicate notifications
 * @param {Array} notifications - List of notifications
 * @returns {Promise<Array>} List of duplicate notification UUIDs to remove
 */
export const cleanupDuplicateNotifications = async (notifications) => {
  try {
    // Create a map to track notifications by userConfigUuid
    const notificationsByConfigId = new Map();
    const duplicatesToRemove = [];
    
    // Group notifications by type and userConfigUuid
    for (const notification of notifications) {
      if (notification.isDeleted) continue;
      
      try {
        // Parse jsonData
        const jsonData = typeof notification.jsonData === 'string' 
          ? JSON.parse(notification.jsonData) 
          : notification.jsonData;
        
        if (!jsonData || !jsonData.userConfigUuid) continue;
        
        // Create a unique key for type + userConfigUuid
        const key = `${notification.type}_${jsonData.userConfigUuid}`;
        
        if (!notificationsByConfigId.has(key)) {
          // First notification for this configId, add it to the map
          notificationsByConfigId.set(key, [notification]);
        } else {
          // Add to the list for this configId
          notificationsByConfigId.get(key).push(notification);
        }
      } catch (error) {
        console.error('Error parsing notification jsonData:', error);
      }
    }
    
    // For each group of notifications with the same configId, 
    // keep only the newest unread notification
    for (const [key, notificationGroup] of notificationsByConfigId.entries()) {
      if (notificationGroup.length <= 1) continue; // No duplicates
      
      // Find unread notifications
      const unreadNotifications = notificationGroup.filter(n => !n.isRead);
      
      if (unreadNotifications.length <= 1) continue; // No duplicate unread notifications
      
      // Sort by timestamp (newest first)
      unreadNotifications.sort((a, b) => 
        new Date(b.timestamp || b.createdAt) - new Date(a.timestamp || a.createdAt)
      );
      
      // Keep the newest, mark others for deletion
      const [newest, ...duplicates] = unreadNotifications;
      duplicatesToRemove.push(...duplicates.map(n => n.uuid));
    }
    
    // Delete duplicates
    if (duplicatesToRemove.length > 0) {
      console.log(`[notificationService] Removing ${duplicatesToRemove.length} duplicate notifications`);
      await dbStorageService.markForDeletion('Notification', duplicatesToRemove);
    }
    
    return duplicatesToRemove;
  } catch (error) {
    console.error('Error cleaning up duplicate notifications:', error);
    return [];
  }
};

/**
 * Check for overdue medications and create notifications
 * @param {number} userId - The current user ID
 * @param {object} notificationRegistry - The notification registry instance
 * @returns {Promise<Array>} Array of new notifications created
 */
export const checkOverdueMedications = async (userId, notificationRegistry) => {
  // ASG features removed - medication notifications disabled
  console.log('[NotificationChecker] checkOverdueMedications disabled (ASG features removed)');
  return [];
};

/**
 * Check for overdue health checks and create notifications
 * @param {number} userId - The current user ID
 * @param {object} notificationRegistry - The notification registry instance
 * @returns {Promise<Array>} Array of new notifications created
 */
export const checkOverdueHealthChecks = async (userId, notificationRegistry) => {
  // ASG features removed - health check notifications disabled
  console.log('[NotificationChecker] checkOverdueHealthChecks disabled (ASG features removed)');
  return [];
};
